import {
  CampaignIcon,
  ConvertIcon,
  SpotIcon,
  GiftIcon,
  CoinInfoIcon,
  MarketInsightsIcon,
  MarketOverviewIcon,
  BlogIcon,
  UsersGuideIcon,
  ReferralIcon,
  // P2pIcon,
  VIPProgramIcon,
  BuyCryptoIcon,
} from 'src/packages/icons';
import { Link, NavLinkWithDropdownProps } from 'src/packages/core/navlink';
import { config } from 'src/config';

export const UserLinks: Link[] = [
  {
    label: 'header.menu.profile_icon.sublink.security',
    url: `${config.coinflareUrl}/user/security`,
  },
  {
    label: 'header.menu.profile_icon.sublink.verification',
    url: `${config.coinflareUrl}/user/verification`,
  },
  { label: 'header.menu.profile_icon.sublink.my_fees', url: `${config.coinflareUrl}/user/my-fees` },
  {
    label: 'header.menu.profile_icon.sublink.referral',
    url: `${config.coinflareUrl}/user/referral`,
  },
  {
    label: 'header.menu.profile_icon.sublink.affiliate',
    url: `${config.coinflareUrl}/affiliate`,
    restricted: (user?: any) => !user || !user['isAffiliate'],
  },
  {
    label: 'header.menu.profile_icon.sublink.api_management',
    url: `${config.coinflareUrl}/user/api`,
  },
  {
    label: 'header.menu.profile_icon.sublink.settings',
    url: `${config.coinflareUrl}/user/settings`,
  },
  { label: 'header.menu.profile_icon.sublink.feedback', url: `${config.feedbackUrl}` },
];

export const MarketsLinks: Link[] = [
  {
    label: 'header.menu.markets.sublink.market_overview',
    icon: MarketOverviewIcon,
    sublabel: 'header.menu.markets.sublink.market_overview.sublabel',
    url: `${config.coinflareUrl}/markets`,
  },
  {
    label: 'header.menu.markets.sublink.market_insights',
    icon: MarketInsightsIcon,
    sublabel: 'header.menu.markets.sublink.market_insights.sublabel',
    url: `${config.coinflareUrl}/market/insights`,
    new: true,
  },
  {
    label: 'header.menu.markets.sublink.coin_info',
    icon: CoinInfoIcon,
    sublabel: 'header.menu.markets.sublink.coin_info.sublabel',
    url: `${config.coinflareUrl}/coin-info`,
    new: true,
  },
];

export const BuyCryptoLinks: Link[] = [
  {
    label: 'header.menu.buy_crypto.sublink.third_party_payment',
    icon: BuyCryptoIcon,
    sublabel: 'header.menu.buy_crypto.sublink.third_party_payment.sublabel',
    url: `${config.coinflareUrl}/f2c`,
  },
];

export const getTradeLinks = (
  convertPlatformEnabled: boolean,
  tradeSpotPlatformEnabled: boolean
  // p2pPlatformEnabled: boolean
): Link[] => {
  return [
    {
      label: 'header.menu.trade.sublink.convert',
      icon: ConvertIcon,
      sublabel: 'header.menu.trade.sublink.convert.sublabel',
      url: `${config.coinflareUrl}/convert`,
      restricted: () => !convertPlatformEnabled,
    },
    {
      label: 'header.menu.trade.sublink.spot',
      icon: SpotIcon,
      sublabel: 'header.menu.trade.sublink.spot.sublabel',
      url: config.spotUrl,
      restricted: () => !tradeSpotPlatformEnabled,
    },
    // {
    //   label: 'header.menu.trade.sublink.p2p',
    //   icon: P2pIcon,
    //   sublabel: 'header.menu.trade.sublink.p2p.sublabel',
    //   url: config.p2pUrl,
    //   new: true,
    //   restricted: () => !p2pPlatformEnabled,
    // },
  ];
};

export const LearnLinks: Link[] = [
  {
    label: 'header.menu.learn.sublink.blog',
    sublabel: 'header.menu.learn.sublink.blog.sublabel',
    icon: BlogIcon,
    url: config.blogUrl,
    target: '_blank',
    new: true,
  },
  {
    label: 'header.menu.learn.sublink.users_guide',
    sublabel: 'header.menu.learn.sublink.users_guide.sublabel',
    icon: UsersGuideIcon,
    url: config.helpCenterUrl,
    target: '_blank',
  },
];

export const MoreLinks: Link[] = [
  {
    label: 'header.menu.more.sublink.campaigns',
    icon: CampaignIcon,
    url: config.campaignsUrl,
  },
  {
    label: 'header.menu.more.sublink.referral',
    icon: ReferralIcon,
    url: config.referralUrl,
    new: true,
  },
  {
    label: 'header.menu.more.sublink.rewards_hub',
    icon: GiftIcon,
    url: config.rewardsHubUrl,
    new: true,
  },
  {
    label: 'header.menu.more.sublink.vip_program',
    icon: VIPProgramIcon,
    url: config.vipProgramUrl,
    new: true,
  },
];

export const AssetsLinks: Link[] = [
  { label: 'header.menu.assets.sublink.spot_wallet', url: `${config.coinflareUrl}/assets/spot` },
  {
    label: 'header.menu.assets.sublink.derivatives_account',
    url: `${config.coinflareUrl}/assets/derivatives`,
  },
  {
    label: 'header.menu.assets.sublink.earn_account',
    url: `${config.coinflareUrl}/assets/earn`,
  },
];

export const getOrdersLinks = (
  earnPlatformEnabled: boolean,
  tradeSpotPlatformEnabled: boolean,
  tradeDerivativesPlatformEnabled: boolean
): Link[] => {
  return [
    {
      label: 'header.menu.orders.sublink.spot_orders',
      url: `${config.coinflareUrl}/orders/spot`,
      restricted: () => !tradeSpotPlatformEnabled,
    },
    {
      label: 'header.menu.orders.sublink.derivatives_orders',
      url: `${config.coinflareUrl}/orders/derivatives`,
      restricted: () => !tradeDerivativesPlatformEnabled,
    },
    {
      label: 'header.menu.orders.sublink.earn_orders',
      url: `${config.coinflareUrl}/orders/earn`,
      restricted: () => !earnPlatformEnabled,
    },
  ];
};

export const ProfileIconLinks: Link[] = [
  {
    label: 'header.menu.profile_icon.sublink.security',
    url: `${config.coinflareUrl}/user/security`,
  },
  {
    label: 'header.menu.profile_icon.sublink.verification',
    url: `${config.coinflareUrl}/user/verification`,
  },
  {
    label: 'header.menu.profile_icon.sublink.my_fees',
    url: `${config.coinflareUrl}/user/my-fees`,
  },
  {
    label: 'header.menu.profile_icon.sublink.referral',
    url: `${config.coinflareUrl}/user/referral`,
  },
  {
    label: 'header.menu.profile_icon.sublink.affiliate',
    url: `${config.coinflareUrl}/affiliate`,
    restricted: (user?: any) => !user || !user['isAffiliate'],
  },
  {
    label: 'header.menu.profile_icon.sublink.api_management',
    url: `${config.coinflareUrl}/user/api`,
  },
  {
    label: 'header.menu.profile_icon.sublink.settings',
    url: `${config.coinflareUrl}/user/settings`,
  },
  {
    label: 'header.menu.profile_icon.sublink.feedback',
    url: `${config.feedbackUrl}`,
    target: '_blank',
  },
];

export const getBurgerMenuLinks = (
  convertPlatformEnabled: boolean,
  earnPlatformEnabled: boolean,
  tradeSpotPlatformEnabled: boolean,
  tradeDerivativesPlatformEnabled: boolean,
  p2pPlatformEnabled: boolean
): (Link | NavLinkWithDropdownProps)[] => [
  {
    title: 'header.menu.buy_crypto',
    sublinks: [
      {
        label: 'header.menu.buy_crypto.sublink.third_party_payment',
        url: `${config.coinflareUrl}/f2c`,
      },
    ],
  },
  {
    title: 'header.menu.markets',
    sublinks: [
      {
        label: 'header.menu.markets.sublink.market_overview',
        url: `${config.coinflareUrl}/markets`,
      },
      {
        label: 'header.menu.markets.sublink.market_insights',
        url: `${config.coinflareUrl}/market/insights`,
        new: true,
      },
      {
        label: 'header.menu.markets.sublink.coin_info',
        url: `${config.coinflareUrl}/coin-info`,
        new: true,
      },
    ],
  },
  {
    title: 'header.menu.trade',
    restricted: () => !convertPlatformEnabled && !tradeSpotPlatformEnabled && !p2pPlatformEnabled,
    sublinks: [
      {
        label: 'header.menu.trade.sublink.convert',
        url: `${config.coinflareUrl}/convert`,
        restricted: () => !convertPlatformEnabled,
      },
      {
        label: 'header.menu.trade.sublink.spot',
        url: config.spotUrl,
        restricted: () => !tradeSpotPlatformEnabled,
      },
      // {
      //   label: 'header.menu.trade.sublink.p2p',
      //   url: config.p2pUrl,
      //   new: true,
      //   restricted: () => !p2pPlatformEnabled,
      // },
    ],
  },
  {
    label: 'header.menu.derivatives',
    url: config.derivativesUrl,
    restricted: () => !tradeDerivativesPlatformEnabled,
  },
  {
    label: 'header.menu.earn',
    url: config.earnUrl,
    restricted: () => !earnPlatformEnabled,
  },
  {
    label: 'header.menu.affiliate',
    url: `${config.coinflareUrl}/affiliate`,
  },
  {
    title: 'header.menu.more',
    sublinks: [
      { label: 'header.menu.more.sublink.campaigns', url: config.campaignsUrl },
      {
        label: 'header.menu.more.sublink.referral',
        url: config.referralUrl,
        new: true,
      },
      {
        label: 'header.menu.more.sublink.rewards_hub',
        url: config.rewardsHubUrl,
        new: true,
      },
      {
        label: 'header.menu.more.sublink.vip_program',
        url: config.vipProgramUrl,
        new: true,
      },
    ],
  },
  {
    title: 'header.menu.assets',
    sublinks: [
      { label: 'header.menu.assets.sublink.spot_wallet', url: `${config.coinflareUrl}/assets` },
      {
        label: 'header.menu.assets.sublink.derivatives_account',
        url: `${config.coinflareUrl}/assets/derivatives`,
      },
      {
        label: 'header.menu.assets.sublink.earn_account',
        url: `${config.coinflareUrl}/assets/earn`,
      },
    ],
    restricted: (user?: any) => !user,
  },
  {
    title: 'header.menu.orders',
    restricted: (user?: any) =>
      !user ||
      (!earnPlatformEnabled && !tradeSpotPlatformEnabled && !tradeDerivativesPlatformEnabled),
    sublinks: [
      {
        label: 'header.menu.orders.sublink.spot_orders',
        url: `${config.coinflareUrl}/orders/spot`,
        restricted: () => !tradeSpotPlatformEnabled,
      },
      {
        label: 'header.menu.orders.sublink.derivatives_orders',
        url: `${config.coinflareUrl}/orders/derivatives`,
        restricted: () => !tradeDerivativesPlatformEnabled,
      },
      {
        label: 'header.menu.orders.sublink.earn_orders',
        url: `${config.coinflareUrl}/orders/earn`,
        restricted: () => !earnPlatformEnabled,
      },
    ],
  },
];

export const LoggedInUserMobileNavAdditionalLinks: (Link | NavLinkWithDropdownProps)[] = [
  {
    title: 'header.menu.assets',
    sublinks: [
      { label: 'header.menu.assets.sublink.spot_wallet', url: `${config.coinflareUrl}/assets` },
      {
        label: 'header.menu.assets.sublink.derivatives_account',
        url: `${config.coinflareUrl}/assets/derivatives`,
      },
      {
        label: 'header.menu.assets.sublink.earn_account',
        url: `${config.coinflareUrl}/assets/earn`,
      },
    ],
    restricted: (user?: any) => !user,
  },
  {
    title: 'header.menu.orders',
    sublinks: [
      {
        label: 'header.menu.orders.sublink.spot_orders',
        url: `${config.coinflareUrl}/orders/spot`,
      },
      {
        label: 'header.menu.orders.sublink.derivatives_orders',
        url: `${config.coinflareUrl}/orders/derivatives`,
      },
      {
        label: 'header.menu.orders.sublink.earn_orders',
        url: `${config.coinflareUrl}/orders/earn`,
      },
    ],
    restricted: (user?: any) => !user,
  },
];
